// import wj from '@/plugins/wjtools'
// import * as api from '@/api'

export default {
  // async getCanSubmitOrder({ state, commit }, params) {
  //   const res = await api.getCanSubOrder(params)
  //   commit('setCanSubmitOrder', res)
  // }
}
